module.exports = "img {\n  width: 80%;\n  max-width: 500px;\n  display: block;\n  margin: 0 auto; }\n"